import {Doughnut} from "vue-chartjs";
import updateChartMixin from "@/components/widgets/updateChartMixin";
import i18n from "@/i18n";

export default {
    extends: Doughnut,
    mixins: [updateChartMixin],
    props: {
        options: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            completed: 0,
            all: 10900,
            rest: 10900
        };
    },
    computed: {
        data() {
            return {
                datasets: [{
                    data: [this.completed, this.rest],
                    backgroundColor: ["green", "#8e71c7"]
                }],
                labels: [
                    i18n.t("monitoring.targetPie.completed", { percent: Math.round(this.completed / this.all * 100) }),
                    i18n.t("monitoring.targetPie.rest", { percent: Math.round(this.rest / this.all * 100) }),
                ]
            }
        }
    },
    methods: {
        set(data) {
            this.all = data.all;
            this.completed = data.completed;
            this.rest = Math.max(0, data.all - data.completed);
            this.renderChart(this.data, this.options);
        },
        newAction() {
            this.all--;
            this.completed++;
            this.renderChart(this.data, this.options);
        }
    },
};